import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableShowIndividualItemsOnOrderSidebar = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enableShowIndividualItemsOnOrderSidebar);
};
